import { useTranslation } from 'react-i18next';

import { Heading } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';
import { wandIcon } from '@app/assets';

interface CardsHeaderSectionProps {
  isVisuallyHidden: boolean;
}

export function CardsHeaderSection({ isVisuallyHidden }: CardsHeaderSectionProps) {
  const { t } = useTranslation();

  return (
    <section
      className={cn('flex items-center justify-center gap-2.5', { 'opacity-0': isVisuallyHidden })}
    >
      <img src={wandIcon} alt="wand" className="w-[26px]" />
      <Heading level={5}>{t('daily_card_preview.choose_your_card')}</Heading>
    </section>
  );
}
